import * as Models from './models';

const preview = (state): Models.State.IState => state.get('preview');

export const cellsHeight = state => preview(state).get('cellsHeight');
export const previewsHtml = state => preview(state).get('previewsHtml');
export const screenIdsReadyForOutput = state => preview(state).get('screenIdsReadyForOutput');
